import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import { ApiResponse } from '../api-response.model';

@Injectable({
  providedIn: 'root',
})
export class BusinessLineService {
  private baseUrl: string;

  constructor(private http: HttpClient, private config: ApiConfiguration) {
    this.baseUrl = `${this.config.rootUrl}/linea-negocio`;
  }

  getBusinessLines(): Observable<
    ApiResponse<{ businessLines: BusinessLine[] }>
  > {
    return this.http.get<ApiResponse<{ businessLines: BusinessLine[] }>>(
      `${this.baseUrl}/activas`
    );
  }

  createBusinessLine(
    description: string
  ): Observable<ApiResponse<BusinessLine>> {
    return this.http.post<ApiResponse<BusinessLine>>(`${this.baseUrl}`, {
      description,
    });
  }

  updateBusinessLine(
    idBusinessLine: number | string,
    description: string
  ): Observable<ApiResponse<BusinessLine>> {
    return this.http.patch<ApiResponse<BusinessLine>>(
      `${this.baseUrl}/${idBusinessLine}`,
      { description }
    );
  }

  updateStateByIdBusinessLine(
    idBusinessLine: number | string,
    state: string
  ): Observable<ApiResponse<BusinessLine>> {
    return this.http.patch<ApiResponse<BusinessLine>>(
      `${this.baseUrl}/estado/${idBusinessLine}`,
      { state }
    );
  }

  getAll(): Observable<ApiResponse<{ businessLines: BusinessLine[] }>> {
    return this.http.get<ApiResponse<{ businessLines: BusinessLine[] }>>(
      `${this.baseUrl}`
    );
  }

  getById(
    idBusinessLine: number | string
  ): Observable<ApiResponse<BusinessLine>> {
    return this.http.get<ApiResponse<BusinessLine>>(
      `${this.baseUrl}/${idBusinessLine}`
    );
  }

  getByDescription(description: string): Observable<ApiResponse<BusinessLine>> {
    return this.http.get<ApiResponse<BusinessLine>>(
      `${this.baseUrl}/obtener-por-descripcion/${description}`
    );
  }
}
